import * as React from "react"

import { cva, type VariantProps } from "../cva.ts"
import { withClass } from "../to-wrapped-children.ts"
import { useFieldRefs } from "./field.tsx"

export const Label = (props: Label.Props) => {
  const field = useFieldRefs()
  const ref = React.useRef<HTMLLabelElement | null>(null)

  React.useImperativeHandle(props.ref, () => ref.current!)
  React.useImperativeHandle(field.label, () => ref.current!)

  return (
    <label
      data-ui="Label"
      id={field.uuid("label")}
      htmlFor={field.uuid("control")}
      ref={ref}
      {...withClass(props, classForLabel)}
    />
  )
}

export namespace Label {
  export type Props = React.ComponentProps<"label"> & VariantProps<typeof classForLabel>
}

export const classForLabel = cva(["text-sm text-gray-12"])
